export * from './PluginSettings';
import PluginSettings from './PluginSettings';
export default PluginSettings;
